var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.text, placement: _vm.placement, classes: 'tight' }),expression:"{ content: text, placement: placement, classes: 'tight' }"}],staticClass:"vcv-help-tooltip"},[_vm._v("?")])
}
var staticRenderFns = []

export { render, staticRenderFns }